import React from "react";
import { useNavigate } from "react-router-dom";
import tw from "tailwind-styled-components";
import { FaWarehouse, FaUsers, FaUniversity, FaExclamationCircle, FaUserTie, FaMoneyBillWave, FaCreditCard, FaBriefcase, FaUser } from "react-icons/fa";
import { TbCalendarDue } from "react-icons/tb";
import { FaMoneyBill, FaMoneyBillTrendUp } from "react-icons/fa6";
import { MdSettings } from "react-icons/md";
import { FiMapPin } from "react-icons/fi";

// const actions = [
//     { icon: <FaWarehouse size={24} className="text-gray-500" />, label: "Manage Inventory", bg: "bg-purple-100", path: "/property-list" },
//     { icon: <FaUsers size={24} className="text-gray-500" />, label: "Manage Tenants", bg: "bg-green-100", path: "/tenants/active" },
//     // { icon: <FaUniversity size={24} />, label: "Bank Accounts", bg: "bg-yellow-100", path: "/bank-accounts" },
//     { icon: <FaExclamationCircle size={24} className="text-gray-500" />, label: "Send Notice", bg: "bg-red-100", path: "/notice" },
//     { icon: <FaUserTie size={24} className="text-gray-500" />, label: "Manage Staff", bg: "bg-orange-100", path: "/staffs" },
//     { icon: <TbCalendarDue size={24} className="text-gray-500" />, label: "Tenant Dues", bg: "bg-blue-100", path: "/finance/dues" },
//     { icon: <FaMoneyBill size={24} className="text-gray-500" />, label: "Missed Rent", bg: "bg-blue-100", path: "/missed-rent" },
//     { icon: <FaMoneyBillWave size={24} className="text-gray-500" />, label: "Expenses", bg: "bg-blue-100", path: "/finance/expenses" },
//     { icon: <FaUser size={24} className="text-gray-500" />, label: "Leads", bg: "bg-green-100", path: "/leads" },
//     { icon: <MdSettings size={24} className="text-gray-500" />, label: "Settings", bg: "bg-gray-100", path: "/settings" },
// ];

// const QuickAction = () => {
//     const navigate = useNavigate();

//     return (
//         <Container>
//             <Title>Quick Actions</Title>
//             <Grid>
//                 {actions.map((action, index) => (
//                     <ActionCard key={index} className={action.bg} onClick={() => navigate(action.path)}>
//                         <IconWrapper>{action.icon}</IconWrapper>
//                         <Label>{action.label}</Label>
//                     </ActionCard>
//                 ))}
//             </Grid>
//         </Container>
//     );
// };

// const Container = tw.div`shadow-md rounded-lg gap-4 p-4 bg-white`;
// const Title = tw.h2`text-lg font-semibold mb-4 text-gray-800`;
// const Grid = tw.div`grid sm:grid-cols-3 grid-cols-2 gap-3`;
// const ActionCard = tw.div`flex flex-col items-center px-4 py-4 rounded-lg shadow-sm cursor-pointer transition hover:shadow-md`;
// const IconWrapper = tw.div`w-12 h-10 flex items-center justify-center rounded-lg`;
// const Label = tw.p`text-sm text-gray-600 font-normal text-center`;

const actions = [
  { icon: FaWarehouse, label: "Inventory", path: "/inventory/operational" },
  { icon: FaUsers, label: "Deals", path: "/deals/pipeline" },
  { icon: FaExclamationCircle, label: "Commission", path: "/revenue" },
  { icon: FaUserTie, label: "Owners", path: "/owners" },
  { icon: FiMapPin, label: "Location", path: "/locations" },
  { icon: FaMoneyBill, label: "Reports", path: "/reports" },
  // { icon: FaMoneyBillWave, label: "Expenses", path: "/finance/expenses" },
  // { icon: FaUser, label: "Leads", path: "/leads" },
  { icon: MdSettings, label: "Settings", path: "/settings" },
];

const QuickAction = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <Title>Quick Actions</Title>
      </Header>

      <Grid>
        {actions.map(({ icon: Icon, label, path }) => (
          <ActionCard
            key={label}
            onClick={() => navigate(path)}
            role="button"
            tabIndex={0}
          >
            <IconBadge>
              <Icon size={18} />
            </IconBadge>

            <Label>{label}</Label>
            <Arrow>→</Arrow>
          </ActionCard>
        ))}
      </Grid>
    </Container>
  );
};


const Container = tw.div`
  bg-white rounded-lg p-5
`;

const Header = tw.div`
  flex items-center justify-between mb-4
`;

const Title = tw.h2`
  text-sm font-semibold text-gray-700 uppercase tracking-wide
`;

const Grid = tw.div`
  flex gap-4 overflow-x-auto pb-1
  snap-x snap-mandatory
  scrollbar-hide

  sm:grid sm:grid-cols-3 sm:gap-4
  sm:overflow-visible
`;


const ActionCard = tw.div`
  group flex items-center gap-3
  px-4 py-3 rounded-lg
  border border-gray-100
  bg-white
  cursor-pointer
  transition-all duration-200

  hover:border-blue-300 hover:bg-blue-50
  focus:outline-none focus:ring-2 focus:ring-blue-400

  min-w-[160px] snap-start
  sm:min-w-0
`;


const IconBadge = tw.div`
  w-9 h-9 rounded-md
  bg-gray-100 text-gray-600
  flex items-center justify-center
  group-hover:bg-blue-100 group-hover:text-blue-600
  transition-colors
`;

const Label = tw.span`
  text-sm font-medium text-gray-700 flex-1
`;

const Arrow = tw.span`
  text-gray-400 opacity-0
  group-hover:opacity-100 group-hover:translate-x-0.5
  transition-all
`;

export default QuickAction;
